<script>
import {mapState} from 'vuex'

import { validationClass } from '../../../mixins/validationClass';
import { validateAndSubmit } from '../../../mixins/validateAndSubmit';

export default {
    data() {
        return {
            disableOnSubmit: false,
            isSubmitting: false,
            card_name: '',
            response_errors: false,
            stripe : {},
            elements : {},
            elementStyles : {
                base: {
                        fontSize: '14px',
                        fontWeight: '400',
                        color: '#495057',

                    '::placeholder': {
                        color: '#ced4da',
                    },
                    ':-webkit-autofill': {
                        color: '#495057',
                    },
                },
                invalid: {
                    // color: '#d0021b',

                    // '::placeholder': {
                    //     color: '#d0021b',
                    // },
                },
            },

            elementClasses : {
                focus: 'focused',
                empty: 'empty',
                invalid: 'invalid',
            },

            cardNumber : {},
            cardExpiry : {},
            cardCvc : {},
            loading: false,
            payment_error: false,
            new_club_id: '',
            reason: '',
        }
    },

    props: ['fee', 'paymenturl', 'paymentType', 'stripeKey', 'intent', 'updateIntentUrl', 'hashid'],

    mixins: [validateAndSubmit, validationClass],

    computed: {
        // computed property to get total amount for payment
        total: function () {
            return parseFloat(this.fee).toFixed(2);
        },

        requestData: function () {
            return {
                'card_name': this.card_name ,
                'card_number': this.card_number,
                'card_cvc': this.card_cvc,
                'expiration_month': this.expiration_month,
                'expiration_year': this.expiration_year,
                'payment_type': this.paymentType,
            }
        },
    },

    created() {

    },

    mounted() {
        // initialise stripe elements (if there is a fee to pay)
        if (this.fee > 0) {
            this.stripe = Stripe(this.stripeKey);

            this.elements = this.stripe.elements({
                fonts: [
                    {
                        cssSrc: 'https://fonts.googleapis.com/css?family=Source+Code+Pro',
                    },
                ],
                locale: 'auto'
            });

            this.cardNumber = this.elements.create('cardNumber', {
                style: this.elementStyles,
                classes: this.elementClasses,
            });


            this.cardExpiry = this.elements.create('cardExpiry', {
                style: this.elementStyles,
                classes: this.elementClasses,
            });


            this.cardCvc = this.elements.create('cardCvc', {
                style: this.elementStyles,
                classes: this.elementClasses,
            });

            let self = this;
            setTimeout(function () {
                self.cardNumber.mount('#card_number');
                self.cardCvc.mount('#card_cvc');
                self.cardExpiry.mount('#expiration');
                self.registerElements([self.cardNumber, self.cardExpiry, self.cardCvc], 'change-club');
            }, 1000);
        }
    },

    watch: {
        // watches for changes in the total property to fire a method to update the Stripe intent
        total: function (newTotal, oldTotal) {
            if (newTotal !== oldTotal) {
                this.updateIntent();
            }
        }
    },

    methods: {
        registerElements(elements, containerName) {
            var formClass = '.' + containerName;
            var example = document.querySelector(formClass);

            var form = example.querySelector('form');
            var error = form.querySelector('.error-container');
            var errorMessage = error.querySelector('.error-message');

            // Listen for errors from each Element, and show error messages in the UI.
            var savedErrors = {};
            elements.forEach(function(element, idx) {
                element.on('change', function(event) {
                    if (event.error) {
                        error.classList.add('visible');
                        savedErrors[idx] = event.error.message;
                        errorMessage.innerText = event.error.message;
                    } else {
                        savedErrors[idx] = null;

                        // Loop over the saved errors and find the first one, if any.
                        var nextError = Object.keys(savedErrors)
                        .sort()
                        .reduce(function(maybeFoundError, key) {
                            return maybeFoundError || savedErrors[key];
                        }, null);

                        if (nextError) {
                        // Now that they've fixed the current error, show another one.
                        errorMessage.innerText = nextError;
                        } else {
                        // The user fixed the last error; no more errors.
                        error.classList.remove('visible');
                        }
                    }
                });
            });
        },

        /**
         * General helper method for any forms in the site
         *
         * @param  {obj} event
         *
         * @return {void}
         */
        submitToServer () {
            axios
            .post(this.paymenturl, {
                intent_id: this.intent.id,
                payment_type: this.paymentType,
                new_club_id: this.new_club_id,
                reason: this.reason,
                player_hashid: this.hashid,
            })
            .then(response => {
                if (response.data.message == 'success') {
                    this.loading = false;
                    location.href = response.data.redirectUrl;
                } else {
                    this.response_errors = [[ 'There was an unspecfied error. Please contact Cricket Leinster ']];
                    _self.disableOnSubmit = false;
                }
            })
            .catch(error => {
            });
        },

        // posts back to the server to update the Stripe intent with the new payment amount
        updateIntent() {
            this.loading = true;
            axios
            .post(this.updateIntentUrl, {
                    intent_id: this.intent.id,
                    amount: this.total
                }
            )
            .then(response => {
                this.loading = false;
            })
            .catch(error => {
            });
        },

        // Submits the Stripe payment
        submitPayment() {
            this.disableOnSubmit = true;
            this.loading = true;
            var self  = this;

            this.$validator.validateAll('change-club-form');

            if (this.new_club_id == "" || this.reason == "" || this.card_name == "") {
                this.loading = false;
                this.disableOnSubmit = false;
                return false;
            }

            this.stripe.handleCardPayment(
                self.intent.client_secret, self.cardNumber, {
                    payment_method_data: {
                        billing_details: {name: self.card_name}
                    }
                }
            ).then(function(result) {

                if (result.error) {
                // Display error.message in your UI.
                    self.disableOnSubmit = false;
                    self.loading = false;
                    self.payment_error = result.error;
                } else {
                    self.submitToServer();
                // The payment has succeeded. Display a success message.
                }
            });
        },
    },
}
</script>
